import React, { Fragment, FunctionComponent, useContext, useEffect, useState } from 'react';

import { Text } from '../../../shared/Text';
import { StepperContent, StepperHeader, StepperSubmit } from '../../../shared/Stepper';
import { useForm } from 'react-hook-form';
import { Input } from '../../../shared/Input';
import { formItems } from '../formItems';
import { InputHolder, InputHolderItem } from '../../../shared/InputHolder';
import { FormContext } from '../../../../store/surplus/SurPlusContext';
import { currencyToNumber, numberToCurrency } from '../../../../utils';
import { isLocal } from '../../../../utils';

export const Step2: FunctionComponent<{ id: number }> = ({id}) => {
	const {
		register,
		handleSubmit,
		setFocus,
		formState: {errors, isValid},
	} = useForm({mode: 'onChange', defaultValues: {
		[formItems.mortgage]: (isLocal()) ? '€ 292.000' : ''}});

	useEffect(() => {
		setFocus('mortgage')
	},[setFocus])

	const [completedText, setCompletedText] = useState('');
	const formContext = useContext(FormContext);

	const onSubmit = (data: any) => {
		data[formItems.mortgage] = currencyToNumber(data[formItems.mortgage]);
		formContext.updateForm(data);
		setCompletedText(numberToCurrency(parseInt(data[formItems.mortgage]), true));
	};

	return (
		<Fragment>
			<StepperHeader title="Huidige hypotheek" id={id} completedText={completedText}/>

			<StepperContent>
				<Text as="h2">Wat is de hoogte van je huidige hypotheek?*</Text>
				<form onSubmit={handleSubmit(onSubmit)}>
					<InputHolder>
						<InputHolderItem isFullWidth={true}>
							<Input
								label=""
								name={formItems.mortgage}
								id={formItems.mortgage}
								type="currency"
								hasError={errors[formItems.mortgage]}
								placeholder="€"
								register={register}
								validation={{required: true}}
							/>
							{errors[formItems.mortgage] && (
								<span className="form__error">Vul hoogte van je huidige hypotheek in</span>
							)}
							<Text as="p">
								Vul hier de resterende hypotheekschuld in, niet het bedrag waarvoor de hypotheek oorspronkelijk is afgesloten.
							</Text>
						</InputHolderItem>
					</InputHolder>
					<StepperSubmit id={id} isValidated={isValid}/>
				</form>
			</StepperContent>
		</Fragment>
	);
};
